(async function spSingleProductCountdown() {
  // Guard: only run on product pages
  if (!document.querySelector('.product-single__title')) return;

  const MOUNT_ID = 'sp-product-countdown';
  // Shopify App Proxy path for SalesPop. Shopify adds the shop + signature itself.
  const API_URL = '/apps/salespop/timecountdownwidget';
  const productId = window.meta?.product?.id;

  // Fallback: try extracting product ID from page JSON if meta isn't set
  const productJson = document.getElementById('ProductJson-' + document.querySelector('[data-section-type="product"]')?.dataset?.sectionId);
  const resolvedProductId = productId ?? (productJson ? JSON.parse(productJson.textContent)?.id : null);

  if (!resolvedProductId) {
    console.error('[SP] Missing product ID');
    return;
  }

  let mount = document.getElementById(MOUNT_ID);

  if (!mount) {
    mount = document.createElement('div');
    mount.id = MOUNT_ID;
    mount.className = 'sp-product-countdown';

    // Preferred: just above the variant selector / Add to Cart form (below Afterpay + Zip)
    const cartForm = document.querySelector('.product-single__meta form.product-form[action*="/cart/add"]');
    const title = document.querySelector('.product-single__title');

    if (cartForm) {
      cartForm.parentNode.insertBefore(mount, cartForm);
      console.log('[SP] Mount inserted before the Add to Cart form');
    } else if (title) {
      // Fallback: previous position, under the product title
      title.parentNode.insertBefore(mount, title.nextSibling);
      console.log('[SP] Mount inserted after .product-single__title (fallback)');
    } else {
      console.error('[SP] No anchor element found for countdown.');
      return;
    }
  }

  // Clear any stale timers from hot-reloads or duplicate script calls
  document.querySelectorAll('.sp-countdown-inner').forEach((el) => el.remove());
  mount.innerHTML = '';

  let json;
  try {
    const res = await fetch(
      `${API_URL}` +
      `?product=${encodeURIComponent(resolvedProductId)}` +
      `&collection=true`
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    json = await res.json();
  } catch (err) {
    console.error('[SP] Fetch failed:', err);
    return;
  }

  const s = json?.data?.settingsData;
  if (!json?.success || s?.show_timer_on_collections_page != 1) {
    console.warn('[SP] Timer disabled or API error', json);
    return;
  }

  const end = new Date(s.time * 1000);
  if (end <= Date.now()) {
    console.warn('[SP] Timer already expired');
    return;
  }

  const align =
    s.text_align === 'right'  ? 'flex-end' :
    s.text_align === 'center' ? 'center'   : 'flex-start';

  function unit(val, label) {
    return `
      <div style="
        text-align: center;
        display: flex;
        flex-direction: column;
        min-width: 48px;
      ">
        <span style="
          font-size: ${s.numbers_font_size};
          font-weight: ${s.numbers_font_weight};
          color: ${s.numbers_font_color};
          font-family: ${s.font_family};
        ">${val}</span>
        <span style="
          font-size: ${s.labels_font_size};
          font-weight: ${s.labels_font_weight};
          color: ${s.labels_font_color};
          margin-top: 2px;
        ">${label}</span>
      </div>`;
  }

  function colon() {
    return `
      <span style="
        font-size: ${s.numbers_font_size};
        color: ${s.numbers_font_color};
        align-self: center;
      ">:</span>`;
  }

  let intervalId;

  function render() {
    const ms = end - Date.now();
    if (ms <= 0) {
      mount.innerHTML = '';
      clearInterval(intervalId);
      return;
    }

    const t   = Math.floor(ms / 1000);
    const d   = Math.floor(t / 86400);
    const h   = String(Math.floor((t % 86400) / 3600)).padStart(2, '0');
    const m   = String(Math.floor((t % 3600)  / 60  )).padStart(2, '0');
    const sec = String(t % 60).padStart(2, '0');

    const parts = [];
    if (s.days_on_off)    parts.push(unit(d,   s.days_label    || 'DAYS'));
    if (s.hours_on_off)   parts.push(unit(h,   s.hours_label   || 'HRS'));
    if (s.minutes_on_off) parts.push(unit(m,   s.minutes_label || 'MINS'));
    if (s.seconds_on_off) parts.push(unit(sec, s.seconds_label || 'SECS'));

    const row = parts
      .map((p, i) => p + (i < parts.length - 1 ? colon() : ''))
      .join('');

    mount.innerHTML = `
      <div class="sp-countdown-inner" style="
        display: flex;
        flex-direction: column;
        align-items: ${align};
        margin: 12px 0;
        text-transform: uppercase;
      ">
        <p style="
          margin: 0 0 10px;
          font-size: ${s.title_font_size};
          color: ${s.title_font_color};
          font-weight: ${s.title_font_weight};
          text-transform: none;
          font-family: ${s.font_family};
        ">${s.message || ''}</p>
        <div style="
          display: flex;
          align-items: stretch;
          gap: 8px;
          flex-wrap: wrap;
        ">${row}</div>
      </div>`;
  }

  render();
  intervalId = setInterval(render, 1000);
  console.log('[SP] Countdown mounted → #' + MOUNT_ID);
})();
